import "./App.css";
import CategoryPage from "./components/CategoryPage";
import HomePage from "./components/HomePage";
import GameDetails from "./components/GameDetails";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SearchBox from "./components/SearchBox";
import Login from "./components/Login";
import UserLogin from "./components/UserLogin";
import LoginHeader from "./components/LoginHeader";
function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/home" element={<HomePage />} />
          <Route path="/home/login" element={<Login />} />
          <Route path="/home/header" element={<LoginHeader />} />
          <Route path="/games/:gameid/:category" element={<GameDetails />} />
          <Route path="/category/:category" element={<CategoryPage />} />
          <Route path="/search" element={<SearchBox />} />
          <Route path="/home/check" element={<UserLogin />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
